<script setup lang="ts">
import { BadgeCheck } from 'lucide-vue-next'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

defineProps<{
  class?: string
}>()
</script>

<template>
  <TooltipProvider :delayDuration="450">
    <Tooltip>
      <TooltipTrigger as-child>
        <BadgeCheck
          :class="cn(
            'h-4 w-4 text-primary',
            $props.class
          )"
        />
      </TooltipTrigger>
      <TooltipContent>
        <p>Verified member</p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
</template>
